export default "__VITE_ASSET__CtkrikCM__"